import { TenantStatus } from "../../models/enums/tenant-status.enum";
import { Tenant } from "../../models/interfaces/tenant.interface";

export const tenantMock: Tenant[] = [
  {
    id: '1',
    slug: 'facens',
    name: 'Facens',
    status: TenantStatus.ACTIVE,
    primaryDomain: 'facens.br',
    allowedDomains: ['facens.br', 'alunos.facens.br'],
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '2',
    slug: 'regenerar',
    name: 'Regenerar',
    status: TenantStatus.ACTIVE,

    primaryColor: '#2B6F20',
    logoUrl: 'assets/images/regenerar-logo.svg',

    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  }
];